import { useState } from "react";
import "./ReviewForm.css";
import toast from "react-hot-toast";
import api from "../../../utils/axios";

export default function ReviewForm({ id, type }) {

    const [rate, setRate] = useState(null);

    const [form, setForm] = useState({
        comment: ""
    });

    const [loading, setLoading] = useState(false);

    const [success, setSuccess] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const submit = async () => {
        if (loading || submitted) { return; }
        if (!rate) {
            toast.error("لطفاً امتیاز خود را انتخاب کنید");
            return;
        }
        if (!form.comment.trim()) {
            toast.error("لطفاً نظر خود را وارد کنید");
            return;
        }
        try {
            setLoading(true);
           await api.post(`/auth/${type}/${id}/comments`, { ...form, rate, });   
            
            // Reset form 
            setForm({ comment: "" });
            setRate(null);
            // Disable button permanently 
            setSubmitted(true);
            // Success toast
            toast.success("نظر شما با موفقیت ثبت شد");
        } catch (error) {
            console.error(error);
            toast.error(
                error?.response?.data?.message || "ثبت نظر با خطا مواجه شد");
        }
        finally { setLoading(false); }
    };


    return (

        <div
            className={`review-form ${success ? "review-form-success" : ""
                }`}
        >

            <h3>
                ثبت نظر
            </h3>


            <div className="stars">

                <div className="score">
                    امتیاز شما *:
                </div>

                <div>

                    {
                        [1, 2, 3, 4, 5].map(star => (

                            <span
                                key={star}
                                className={
                                    star <= rate
                                        ? "active"
                                        : ""
                                }

                                onClick={() => {

                                    if (!loading) {
                                        setRate(star);
                                    }

                                }}
                            >
                                ★
                            </span>

                        ))
                    }

                </div>

            </div>


            <textarea
                placeholder="نظر شما"
                value={form.comment}

                disabled={loading || submitted}

                onChange={e =>
                    setForm({
                        ...form,
                        comment: e.target.value
                    })
                }

            />


            <button onClick={submit}
                disabled={loading || submitted}
                className={loading ? "loading" : submitted ? "submitted" : ""} >
                {loading ? (<>
                    <span className="spinner"></span> در حال ارسال... </>)
                    :
                    submitted ? ("نظر ثبت شد ✓") : ("ارسال نظر")}
            </button>


        </div>

    );

}

